import React from "react";
import { useState } from "react";
import { AiOutlineUp, AiOutlineDown } from "react-icons/ai";
import DeleteConfirmation from './ConfirmDelete';

const Course = ({ student, index, updateMarks,updateMarksBackEnd,state,mt,pt,et ,enableInternalMarkEntry,enablePracticalMarkEntry , enableTheoryMarkEntry,deleteStudentFromCourse }) => {
     
     const [showModal, setShowModal] = useState(false);
      
     const handleDelete = (e, index) => {
         setShowModal(true);
       };
     
        
        

  return (
     <div className="flex flex-col">
    <div className="w-full border grid grid-cols-[1fr_.5fr_2fr_4fr_1fr_1fr_1fr_1fr_1fr] gap-1 p-1 text-sm">
              <div className="w-full text-center">
                    <div className="flex justify-center items-center space-x-2">
                        <button
  className={`px-2 py-1 rounded text-white 
    ${state === 'marksentry' ? 'bg-red-600 hover:bg-red-700' : 'bg-gray-400 cursor-not-allowed'}`}
  tabIndex="-1"
  onClick={handleDelete}
  disabled={state !== 'marksentry'}
  
>
  X
</button>
                    </div>
               </div>
               <div className="w-full text-center">
                {index+1}
               </div>
               <div className="w-full text-center">
               <p className="text-gray-700 ">{student.rollno}</p>
               </div>
               <div className="w-full text-left">
               <p className={`${student.name === "NOT FOUND" ? "text-red-600" : "text-gray-700"}`}>
               {student.name}
               </p>
               </div>
               <div  className="w-full  text-center">
                    <input
                    type="number"
                    value={student.midterm||0}
                    onChange={(e) => updateMarks(index, "midterm", Number(e.target.value))}
                    onBlur={(e) => updateMarksBackEnd(index, "midterm", Number(e.target.value))}
                    className={`w-full border-b border-gray-400 focus:border-blue-500 outline-none  text-center font-semibold
                         ${student.midterm < 0 || student.midterm > mt ? 'text-red-500' : 'text-blue-800'}`}
                         disabled={state !== 'marksentry' || !enableInternalMarkEntry}
                    />
               </div>
               <div className="w-full">
                <input
                    type="number"
                    value={student.practical||0}
                    onChange={(e) => updateMarks(index, "practical", Number(e.target.value))}
                    onBlur={(e) => updateMarksBackEnd(index, "practical", Number(e.target.value))}
                    className={`w-full border-b border-gray-400 focus:border-blue-500 outline-none text-center font-semibold
                         ${student.practical < 0 || student.practical >pt ? 'text-red-500' : 'text-blue-800'}`}
                         disabled={state !== 'marksentry'|| !enablePracticalMarkEntry}
                    />
               </div>
               <div className="w-full">
               <input
                    type="number"
                    value={student.endterm || 0}
                    onChange={(e) => updateMarks(index, "endterm", Number(e.target.value))}
                    onBlur={(e) => updateMarksBackEnd(index, "endterm", Number(e.target.value))}
                    className={`w-full border-b border-gray-400 focus:border-blue-500 outline-none text-center font-semibold
                    ${student.endterm < 0 || student.endterm > et ? 'text-red-500' : 'text-blue-800'}`}
                    disabled={state !== 'marksentry' || !enableTheoryMarkEntry}
                    />
               </div>
               <div  className="text-center w-full">
                <p className="w-full">{student.grand_total||0}</p>
               </div>
               
               <div  className="text-center w-full">
               <p className="w-full">{(student.percent ?? 0).toFixed(2)}</p>
               </div>

               
        </div>
        <DeleteConfirmation
        isOpen={showModal}
        onCancel={() => setShowModal(false)}
        onDelete={() => {
          setShowModal(false);
          //call the actual delete function
          deleteStudentFromCourse(student.rollno);
        }}
      />  
       </div>
  );
};

export default Course;
